<template>
  <div>
  <Menu></Menu>
    <main>
    <div class="banner d-flex w-100 h-100 p-5 mx-auto flex-column ">
    <div class="container">
        <div class="row">
              <div class="col-md-6 texto-banner text-white">
                        <h1 class="text-l"><span> ¡Adelántate </span><br> 
                        <span>al cambio!</span></h1> 

                        <div class="d-flex  alto">
                            <img class="flex-shrink-0 me-2 icon-kallpa" src="@/assets/img/calidad1.svg" alt="">
                            <p class="pb-3 mb-0 small lh-sm p-3 text-d">Registrado en: <br>
                               <span> SUPERINTENDENCIA <br>
                                DE BANCA, SEGUROS Y AFP</span>
                            </p>
                        </div>
                         <div class="d-flex alto">
                            <img class="flex-shrink-0 me-2 icon-kallpa" src="@/assets/img/intercambio.svg" alt="">
                            <p class="pb-3 mb-0 small lh-sm p-3 text-d">MÁS DE 3,000 MILLONES<br> 
                             DE DÓLARES NEGOCIADOS <br>
                               CON CLIENTES
                            </p>
                        </div>
              </div>
           <div class="col-md-6 calculadora" id="">
               <div class="col-sm-7 mb-2 me-auto texto-cambio">
                   <p class="text-center text-white">Tipo de cambio <span> actual </span></p>
                   <br>
                            <div class="row t-cambio" v-if="tipoCambio==1">
                                <div class="col-md-6 w-cambio"> <p class="text-center text-white text-xs">
                                  Compramos USD <br> 
                                  <font size="3" face="arial black" >S/{{CambioCompra}}</font> </p></div>
                                <div class="col-md-6 w-cambio"> <p class="text-center text-white text-xs">
                                  Vendemos USD <br>
                                  S/{{CambioVenta}}</p></div>
                            </div>
                            <div class="row t-cambio" v-if="tipoCambio==2">
                                <div class="col-md-6 w-cambio"> <p class="text-center text-white text-xs">
                                  Compramos USD <br> 
                                  S/{{CambioCompra}} </p></div>
                                <div class="col-md-6 w-cambio"> <p class="text-center text-white text-xs">
                                  Vendemos USD <br>
                                  <font size="3" face="arial black"  >S/{{CambioVenta}}</font></p></div>
                            </div>

               </div>

               <div class="col-sm-7 d-flex mb-2 me-auto cambio">
                   <p class="flex-shrink-0 small me-2 mb-0">
                       {{monedaEnviar}} <small class="texto-grande">{{simboloMonedaEnviar}}</small></p>

                  <div class="mb-0 small  me-auto" style="text-align: right;">
                    Envías {{descMonedaEnviar}} 
                    <input type="text" class="v-cambio m-t-1"  id="ValorEnviar" v-model="ValorEnviar" @keyup="CambiarMonedaEnviar"  @keypress="soloFloatEnviar"  size="6"  :disabled="disabled">   
                  </div>
               </div>
               <div class="col-sm-7 mb-2 me-auto ">
                   <img class="flechas-cambio" @click="cambiarMoneda" src="@/assets/img/flechas-cambio.svg" width="30" alt="">
               </div>
               
               <div class="col-sm-7 d-flex me-auto cambio">
                   <p class="flex-shrink-0 small me-2 mb-0">
                    {{monedaRecibir}} <small class="texto-grande">{{simboloMonedaRecibir}}</small></p>
                  <div class="mb-0 small  me-auto" style="text-align: right;">
                    Recibes {{descMonedaRecibir}} 
                    <input type="text" class="v-cambio m-t-1"  id="ValorRecibir" v-model="ValorRecibir"  @keyup="CambiarMonedaRecibir" @keypress="soloFloatRecibir" size="6"  :disabled="disabled">  
                  </div>
                </div>

                <br>
                <div class="col-sm-7 d-flex me-auto cupon">
                  <div class="mb-0  small">
                    <input type="text" class="inp-cupon"  id="ValorCupon" v-model="ValorCupon" autocomplete="off" placeholder="INGRESE SU CUPÓN"  size="24" maxlength="30" :disabled="disabled">  
                  </div>
                  <div class="flex-shrink-0 me-auto mb-0">
                    <button type="button"  class="btn btn-sm btn-registro" @click="validarCupon" >APLICAR</button>
                  </div>
                </div>
                <br>
                        <div v-if="Cupon==1" class="col-sm-7 d-flex me-auto">
                           <div v-if="tipoCambio==1">
                                <p class="text-center " style="color: white;">Hemos mejorado tu tipo de cambio a 
                                <font size="3" face="arial black" >{{NuevoTipo}}</font> 
                                Antes recibías <font size="3" face="arial black" > S/{{ValorRecibir}}</font>
                                ahora recibirás <font size="3" face="arial black" > S/{{ValorRecibir3}}</font>
                                </p>  
                            </div>
                            <div v-if="tipoCambio==2">
                                <p class="text-center " style="color: white;">Hemos mejorado tu tipo de cambio a 
                                <font size="3" face="arial black" >{{NuevoTipo}}</font> 
                                Antes recibías <font size="3" face="arial black" > ${{ValorRecibir}}</font>
                                ahora recibirás <font size="3" face="arial black" > ${{ValorRecibir4}}</font>
                                </p>
                            </div>
                        </div>

                <div class="col-sm-7 mb-2 me-auto">
                    <button type="button" class="btn btn-secondary w-100" @click="iniciarOperacion">Iniciar operación &nbsp; <i class="fas fa-arrow-right"></i></button>
                </div> 
          </div>
      </div>
  </div>       
</div>
<div class="col-md-12 logos">
            <div class="container">
                <section class="customer-logos slider">
                   <div class="slide"><img src="@/assets/img/bcp.png"></div>
                   <div class="slide"><img src="@/assets/img/interbank.png"></div>
                   <!--<div class="slide"><img src="@/assets/img/pichincha.png"></div>-->
                   <div class="slide"><img src="@/assets/img/scotiabank.png"></div>
                   <div class="slide"><img src="@/assets/img/bbva.png"></div>
                   <div class="slide"><img src="@/assets/img/bcp.png"></div>
                   <div class="slide"><img src="@/assets/img/interbank.png"></div>
                   <!--<div class="slide"><img src="@/assets/img/pichincha.png"></div>-->
                   <div class="slide"><img src="@/assets/img/scotiabank.png"></div>
                   <div class="slide"><img src="@/assets/img/bbva.png"></div>
                </section>
             </div>
          </div>

           <div class="col-lg-12"> 
              <div class="container">

                <div class=" w-100 h-100 p-5 mx-auto text-center">
                  <h1 class="titulo-cambio">¿Cómo<span> cambiar</span> con nosotros?</h1>
                  <h4 class="sub-ttulo text-center">Solo 3 simples pasos para que empieces a ahorrar</h4>
                </div>

                <div class="row  w-100 h-100 p-5">
                    <div class="col-md-4 d-flex pt-3">
                        <img class="flex-shrink-0 me-2" src="@/assets/img/movil.png" alt="" width="180">
                        <div class="inf">
                          <p class="numero flex-shrink-0 me-2">1</p>
                            <p class="pb-3 mb-0 small lh-sm" v-text="pasoOperacion1">
                            </p>  
                        </div>   
                    </div>
                    <div class="col-md-4 d-flex pt-3">
                        <img class="flex-shrink-0 me-2" src="@/assets/img/transferencia.png" alt="" width="180">
                       <div class="inf"><p class="numero flex-shrink-0 me-2">2</p>
                            <p class="pb-3 mb-0 small lh-sm"  v-text="pasoOperacion2">
                            </p>
                        </div> 
                    </div>
                    <div class="col-md-4 d-flex pt-3">
                        <img class="flex-shrink-0 me-2" src="@/assets/img/cambio.png" alt="cambiar dolar" width="180">
                         <div class="inf"><p class="numero flex-shrink-0 me-2">3</p>
                            <p class="pb-3 mb-0 small lh-sm"  v-text="pasoOperacion3">
                            </p>
                         </div>
                    </div>
                </div>
                <div class="mx-auto text-center">
                    <h3 class="titulo-cambio">Cómo crear tu cuenta de Kallpa Cambios Paso a paso</h3>
                </div>
                <div class=" w-100 h-100 p-5 mx-auto text-center">
                  <video ref="video" src="@/assets/video/COMO CREO MI CUENTA DE KALLPA CAMBIOS.mp4" id="video-container" width="80%" controls></video>
                </div>

            </div>
          </div>

          <div class="col-lg-12 fondo-black p-5">
             <div class="container">
                
                <div class="row w-100 h-100">
                   <div class="col-md-6">
                        <img class="d-flex me-auto img-kallpa" src="@/assets/img/porque-usar-kallpa.png" alt="cambiar dolar" >
                    </div>
                    <div class="col-md-6">
                        <h1 class="text-green">¿Por qué utilizar <span>Kallpa Cambios </span> ?</h1>
                       <ul class="list-q">
                        <li><i class="fas fa-check"></i> Seguridad. Cambia sin salir de casa.</li>
                        <li><i class="fas fa-check"></i> Cuentas en los principales bancos del Perú.</li>
                        <li><i class="fas fa-check"></i> Pago rápido en el banco que escojas.</li>
                        <li><i class="fas fa-check"></i> … y mejor Tipo de Cambio!</li>
                      </ul>
                        <p class="texto-justify p-q" v-text="porqueKallpa">
                        </p>                   
                    </div>
              </div>
             </div> 
          </div>

          <div id="devices" class="col-lg-12 p-5">
            <div class="container">
               <div class="row">
                   <div class="col-md-6 descargar-app">
                       <h1 class="text-green">
                        <span v-text="descargaApp">  </span></h1>
                        <h1 class="text-black">y realiza tus <span>cambios</span>
                        <br> donde sea que <br>te <span>encuentres</span></h1>
                        
                        <div class="d-flex pt-3">
                            <a class="flex-shrink-0 me-2" href="https://play.google.com/store/apps/details?id=com.futuromovil.kallpacambios" target="_blank"><img src="@/assets/img/android.png" alt=""  class="app-img"></a>
                            <a class="pb-3 mb-0 lh-sm " href="https://apps.apple.com/ec/app/kallpa-cambios/id1593803538" target="_blank"><img src="@/assets/img/ios.png" alt="" class="app-img"></a>
                         </div>
                         <p>Todas nuestras aplicaciones funcionan también fuera del Perú.</p>
                   </div>
                   <div class="col-md-6">
                      <img class="d-flex me-auto m-app" src="@/assets/img/fotos.png" alt="cambiar dolar">
                   </div>
             </div>
            </div> 
         </div>
    </main>

    <div class="modal" tabindex="-1" id="modalMensajeFueraHorario">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p v-text="mensajeFueraHorario"></p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>

    <div class="modal" tabindex="-1" id="modalMensajeFeriado">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p v-text="mensajeFeriado"></p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>

    <div class="modal" tabindex="-1" id="modalMensajeFinSemana">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p v-text="mensajeFinSemana"></p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" tabindex="-1" id="modalMensaje">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{tituloMensaje}}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>{{contenidoMensaje}}</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" tabindex="-1" id="modalMensajePromociones">
        <div class="modal-dialog modal-dialog-centered modal-lg"> <!-- modal-dialog-centered -->
          <div class="modal-content">

            <a href="https://www.kallpasab.com/PromocionesKallpaCambios/TYCKALLPACAMBIOS18oct.pdf" target="_blank" ><img class="img-fluid" src="@/assets/img/DIAKALLPACAMBIOS.png" > </a>
             <button type="button" class="btn btn-iniciar-sesion" data-bs-dismiss="modal">CERRAR</button>

          </div>
        </div>
      </div>
      
      <div class="modal" tabindex="-1" id="modalMensaje5000">
        <div class="modal-dialog">
          <div class="modal-content">
              <div class="m">
                <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button></div>
            <div class="modal-body" style="padding: 2rem 2rem;">
              <p style="font-size: 18px; text-align: justify; " v-text="mensajeMontoMaximo"></p>
              <p style="font-size: 18px; text-align: justify; " v-text="mensajeMontoMaximo2"></p>
            </div>
            <div class="modal-footer">
              <a class="btn btn-iniciar-sesion " :href="linkWhatsApp" target="_blank">Enviar Mensaje</a>
              <button type="button" class="btn btn-registro" data-bs-dismiss="modal" @click="continuarCambioMensaje">Seguir adelante</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" tabindex="-1" id="modalMensaje10000">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p style="font-size: 18px; text-align: justify; " v-text="mensajeMontoMaximoSegundo"></p>
            </div>
            <div class="modal-footer">
              <a type="button" class="btn btn-iniciar-sesion" :href="linkWhatsApp" target="_blank">Enviar Mensaje</a>
            </div>
          </div>
        </div>
      </div>

<footer class=" text-white">
    <div class="container">
        <div class="col-lg-12 footer ">
            <div class="row">
                <div class="col-md-5">
                    <img src="@/assets/img/logo-vertical.png" alt="" width="250">
                    <p>Un servicio de Kallpa Securities S.A.B.</p>
                    <p>RUC: 20492942121</p>
                   
                </div>
                <div class="col-md-4">
                    <h4>Síguenos en:</h4>
                    <a href="https://facebook.com/kallpasablima" target="_blank"><i class="fab fa-facebook-square"></i> @Kallpasablima</a> <br>
                    <a href="https://www.instagram.com/kallpasab/" target="_blank"><i class="fab fa-instagram"></i> @kallpasab</a> <br>
                    <a href="https://twitter.com/KallpaSAB" target="_blank"><i class="fab fa-twitter-square"></i> @KallpaSAB</a> <br>
                    <a href="https://www.linkedin.com/company/kallpa-educa/?viewAsMember=true" target="_blank"><i class="fab fa-linkedin"></i> @KallpaSAB</a>
                </div>
                <div class="col-md-3">
                    <h4 class="cnt">Contáctanos</h4>
                    <ul class="list-footer">
                        <li><i class="fas fa-phone"></i> 630-7500 Anexo 195</li>
                        <li><i class="fas fa-mobile-alt"></i> 940131392</li>
                        <li><i class="fas fa-envelope"></i> clientes@kallpacambios.com</li>
                        <li><i class="fas fa-map-marker-alt"></i>Jr. Monterosa 233 oficina 902,Chacarilla del Estanque, Santiago de Surco.</li>
                        <li>Horario de atención: {{horaInicio}} - {{horaFin}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <hr>
        <div class="col-lg-12 copyright">
            <div class="row d-flex">
                <p class="col-md-8">2021. Kallpa Securities Sociedad Agente de Bolsa // Kallpa Cambios. Todos los derechos reservados. </p>
                <p class="col-md-2"><a :href="urlPoliticasSeguridad" target="_blank" class="poli-term">Políticas de privacidad</a></p>
                <p class="col-md-2"><a :href="urlTerminosCondiciones" target="_blank" class="poli-term">Términos y condiciones</a></p>
            </div>
        </div>
    </div>
</footer>

  <router-link to="/preguntas" class="chat">
    <img style="margin: 11px;" src="@/assets/img/chat.png" width="">
  </router-link>

  </div>
</template>

<script>

import auth from '@/services/auth'
import helpers from '@/services/helpers'
import crypt from '@/services/crypto'


import Header from "./Header";
import Menu from "./Menu";
import Footer from "./Footer";

import Vue from 'vue';
import vueNumeralFilterInstaller from 'vue-numeral-filter';

Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' });



export default {
  name: "Main",
  
  components: {
    Header,
    Menu,
    Footer,
  },
  data() {
    return {
      ValorEnviar:"",
      referenciaDolar: this.$store.getters.getTipoCambio('venta'),
      Cupon:0,
      ValorCupon:"",
      NuevoTipo:"",
      ValorRecibir3:"",
      ValorRecibir4:"",
      IdCupon:"",
      MensajeCupon:"",
      DescuentoCupon:"",
      ValorRecibir:"",
      TempValorEnviar:"",
      TempValorRecibir:"",
      ValorRecibir1:"",
      ValorEnviar1:"",
      CambioCompra:"",
      CambioVenta:"",
      tipoCompra:true,
      tipoCambio:1,
      monedaEnviar:"USD",
      simboloMonedaEnviar:"$",
      descMonedaEnviar:"dólares",
      monedaRecibir:"PEN",
      simboloMonedaRecibir:"S/",
      descMonedaRecibir:"soles",
      numeroContacto:"",
      horaInicio:"",
      horaFin:"",
      disabled: true,
      showModal: true,
      tituloMensaje:"",
      contenidoMensaje:"",
      pasoOperacion1:"",
      pasoOperacion2:"",
      pasoOperacion3:"",
      porqueKallpa:"",
      descargaApp:"",
      continuarCambio:0,
      montoMaximo:"",
      montoMaximoSegundo:"",
      mensajeMontoMaximo:"",
      mensajeMontoMaximo2:"",
      mensajeFueraHorario:"",
      mensajeFeriado:"",
      mensajeFinSemana:"",
      mensajeMontoMaximoSegundo:"",
      linkWhatsApp: '',
      urlPoliticasSeguridad: "#",
      urlTerminosCondiciones:  "#",
      horaInicioAtencion: "",
      horaFinAtencion: "",
    };
  },
  beforeCreate() {
    localStorage.removeItem("auth_token");
    
    helpers.actualizarTipoCambio(this);

    auth.listParameters().then(response => {
 
          this.numeroContacto=response.ParametrosGenerales.find(e=>e.Id=="NUKA0001").ValorParametroValor;
          this.horaInicio=response.ParametrosGenerales.find(e=>e.Id=="HOAT0001").ValorParametroValor;
          this.horaFin=response.ParametrosGenerales.find(e=>e.Id=="HOAT0002").ValorParametroValor;
          this.mensajeAtencion=response.ParametrosGenerales.find(e=>e.Id=="MENS0001");
          this.pasoOperacion1=response.ParametrosGenerales.find(e=>e.Id=="TITU0002").NombreParametroValor;
          this.pasoOperacion2=response.ParametrosGenerales.find(e=>e.Id=="TITU0003").NombreParametroValor;
          this.pasoOperacion3=response.ParametrosGenerales.find(e=>e.Id=="TITU0004").NombreParametroValor;
          this.porqueKallpa=response.ParametrosGenerales.find(e=>e.Id=="TITU0005").NombreParametroValor;
          this.descargaApp=response.ParametrosGenerales.find(e=>e.Id=="TITU0006").NombreParametroValor;
          this.montoMaximo=response.ParametrosGenerales.find(e=>e.Id=="MMDO0001").ValorParametroValor;
          this.montoMaximoSegundo=response.ParametrosGenerales.find(e=>e.Id=="MMDO0002").ValorParametroValor;
          this.mensajeMontoMaximo=response.ParametrosGenerales.find(e=>e.Id=="MENS0001").DetalleParametroValor;
          this.mensajeMontoMaximo2=response.ParametrosGenerales.find(e=>e.Id=="MENS0009").DetalleParametroValor;
          this.mensajeMontoMaximoSegundo=response.ParametrosGenerales.find(e=>e.Id=="MENS0004").DetalleParametroValor;
          this.linkWhatsApp=response.ParametrosGenerales.find(e=>e.Id=="MENS0003").DetalleParametroValor;
          this.tituloMensaje=this.mensajeAtencion.NombreParametroValor;
          this.contenidoMensaje=this.mensajeAtencion.DetalleParametroValor;
          this.urlTerminosCondiciones = response.ParametrosGenerales.find(e=>e.Id == "MENS0006").DetalleParametroValor;
          this.urlPoliticasSeguridad = response.ParametrosGenerales.find(e=>e.Id == "MENS0007").DetalleParametroValor;
          this.horaInicioAtencion=response.ParametrosGenerales.find(e=>e.Id=="HOAT0001").DetalleParametroValor;
          this.horaFinAtencion=response.ParametrosGenerales.find(e=>e.Id=="HOAT0002").DetalleParametroValor;
          this.mensajeFueraHorario=response.ParametrosGenerales.find(e=>e.Id=="MENS0002").DetalleParametroValor;
          this.mensajeFeriado=response.ParametrosGenerales.find(e=>e.Id=="MENS0010").DetalleParametroValor;
          this.mensajeFinSemana=response.ParametrosGenerales.find(e=>e.Id=="MENS0011").DetalleParametroValor;
          this.CambioCompra=this.$store.getters.getTipoCambio('compra');
          this.CambioVenta=this.$store.getters.getTipoCambio('venta')
          this.referenciaDolar=this.CambioCompra;
          this.ValorEnviar=numeral(response.ParametrosGenerales.find(e=>e.Id=="MPDC0001").ValorParametroValor).format('0,0.00');
          this.ValorRecibir=numeral(numeral(this.ValorEnviar).value()*this.referenciaDolar).format('0,0.00');
          if(this.referenciaDolar!=null){
            this.disabled=false;
          }
          else{
            this.disabled=true;
          }

    });

    //   messagePromotions 
    
  /*
    auth.validateTimeGeneral().then(response => {
           if(response==0 || response==1){
            $('#modalMensajePromociones').modal('show');
           }

    });
    */
    
  },

methods: {
 
   iniciarOperacion(){
    /*
         auth.validateTime().then(response => {
           if(response=="True"){
              localStorage.setItem("valorEnviar", this.ValorEnviar);
              localStorage.setItem("valorRecibir", this.ValorRecibir);
              localStorage.setItem("tipoCambio", this.tipoCambio);
              localStorage.setItem("cambioCompra", this.$store.getters.getTipoCambio('compra'));
              localStorage.setItem("cambioVenta",this.$store.getters.getTipoCambio('venta'));
              
              this.$router.push("/auth-login").catch(err => {});
           }
           else{
              $('#modalMensajeFueraHorario').modal('show');
           }
    */
      
        auth.validateTimeGeneral().then(response => {
           if(response==0){
              $('#modalMensajeFueraHorario').modal('show');
           }
           else if(response==1)
           {
              localStorage.setItem("valorEnviar", this.ValorEnviar);
              localStorage.setItem("valorRecibir", this.ValorRecibir);
              localStorage.setItem("tipoCambio", this.tipoCambio);
              localStorage.setItem("cambioCompra", this.$store.getters.getTipoCambio('compra'));
              localStorage.setItem("cambioVenta",this.$store.getters.getTipoCambio('venta'));
              
              this.$router.push("/auth-login").catch(err => {});

           }
           else if(response==2)
           {
              $('#modalMensajeFeriado').modal('show');
           }
           else if(response==3)
           {
              $('#modalMensajeFinSemana').modal('show');
           }

         });

    },
    async cerrarSesion(){
      if(await auth.logout()){
        this.$router.push("/auth-login").catch(err => {});
      }
    },
    getNombreUsuario(){
      return this.$store.getters.getAuthUserName;
    },
    getAreaActual(){
      return this.$store.getters.getAuthUser('areaActualTexto');
    },
    getPermisoActual(){
      return this.$store.getters.getAuthUser('permisoActualTexto');
    },
    soloFloatEnviar($event){
      helpers.soloFloat($event);
      this.ValorEnviar1=$event.target.value;
    },
    soloFloatRecibir($event){
        
        helpers.soloFloat($event);
        this.ValorRecibir1=$event.target.value;
        
    },
    CambiarMonedaRecibir(){  

      const regExp = new RegExp( /^\d{0,6}(\.\d{0,2})*(,\d+)?$/ ); // --- sin comillas
      
      let resultado = regExp.test( this.ValorRecibir );
      //console.log("resultado"+resultado);
      if (resultado) {
        this.TempValorRecibir = this.ValorRecibir;
      } else {
        this.ValorRecibir=this.TempValorRecibir;
      }
        this.ValorEnviar=numeral(helpers.convertirEnviar(numeral(this.ValorRecibir).value(),this.referenciaDolar,this.tipoCompra)).format('0,0.00');
        //this.ValorRecibir=numeral(this.ValorRecibir).format('0,0.00');
    },
    CambiarMonedaEnviar(){
      const regExp = new RegExp( /^\d{0,6}(\.\d{0,2})*(,\d+)?$/ ); // --- sin comillas
      
      let resultado = regExp.test( this.ValorEnviar );
      //console.log("resultado"+resultado);
      if (resultado) {
        this.TempValorEnviar = this.ValorEnviar;
      } else {
        this.ValorEnviar=this.TempValorEnviar;
      }
      
        this.ValorRecibir=numeral(helpers.convertirRecibir(numeral(this.ValorEnviar).value(),this.referenciaDolar,this.tipoCompra)).format('0,0.00');
        //this.ValorEnviar=numeral(this.ValorEnviar).format('0,0.00');

        // Mostrar Monto Cupon 
        if(this.tipoCambio=="1"){
        this.NuevoTipo=(Number(this.referenciaDolar)+Number(this.DescuentoCupon)).toFixed(4);
        this.ValorRecibir3=numeral(helpers.convertirRecibir(numeral(this.ValorEnviar).value(),this.referenciaDolar+this.DescuentoCupon,this.tipoCompra)).format('0,0.00');
        }else{
        this.NuevoTipo=(Number(this.referenciaDolar)-Number(this.DescuentoCupon)).toFixed(4);
        this.ValorRecibir4=numeral(helpers.convertirRecibir(numeral(this.ValorEnviar).value(),this.referenciaDolar-this.DescuentoCupon,this.tipoCompra)).format('0,0.00');
        }
        
      },

      validarCupon(){
        //console.log(this.ValorCupon);
        auth.validarCoupon(this.ValorCupon).then((response) => {
                  //console.log(response);
                  if(response.data.m_Item1[0].Mensaje=="OK"){
                      this.Cupon=1;
                      this.IdCupon=response.data.m_Item1[0].Id
                      this.MensajeCupon=response.data.m_Item1[0].Mensaje
                      this.DescuentoCupon=response.data.m_Item1[0].Descuento
                      this.CambiarMonedaEnviar();
                      
                  }else{

                      this.Cupon=0;
                      this.IdCupon=response.data.m_Item1[0].Id
                      this.MensajeCupon=response.data.m_Item1[0].Mensaje
                      this.DescuentoCupon=response.data.m_Item1[0].Descuento
                      toastr["error"](this.MensajeCupon);
                  }
                })
                .catch((error) => {
                  console.log(error);

                });
      },

      continuarCambioMensaje(){
        this.iniciarOperacion();
      },
    
      cambiarMoneda(){
        if(this.tipoCompra==true){
          this.tipoCambio=2;
           this.tipoCompra=false;
           this.monedaEnviar="PEN";
           this.simboloMonedaEnviar="S/";
           this.descMonedaEnviar="soles";
           this.monedaRecibir="USD";
           this.simboloMonedaRecibir="$";
           this.descMonedaRecibir="dólares";
           this.referenciaDolar=this.$store.getters.getTipoCambio('venta');
           this.CambiarMonedaEnviar();
        }
        else{
           this.tipoCompra=true;
           this.tipoCambio=1;
           this.monedaEnviar="USD";
           this.simboloMonedaEnviar="$";
           this.descMonedaEnviar="dólares";
           this.monedaRecibir="PEN";
           this.simboloMonedaRecibir="S/";
           this.descMonedaRecibir="soles";
           this.referenciaDolar=this.$store.getters.getTipoCambio('compra');
           this.CambiarMonedaEnviar();
        }
      },

},

mounted() {

  $('.customer-logos').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 1500,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      responsive: [{
          breakpoint: 768,
          settings: {
              slidesToShow: 4
          }
      }, {
          breakpoint: 520,
          settings: {
              slidesToShow: 3
          }
      }]
  });


  jQuery('.mm-video-overlay').on('click', function() {
    destroyVideo();
  });

  jQuery('.mm-launch').on('click',function() {
    deployVideo();
  });

  },
 
};
</script>



// WEBPACK FOOTER //
// src/layouts/Main.vue